var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GroupEditor from "./groupEditor";
import { Input } from "@mui/joy";
import { useLogger } from "@/utils/loggerService";
import copy from "fast-copy";
export default function (_a) {
    var filter = _a.filter, notifyFilterUpdate = _a.onFilterUpdated, module = _a.module, inputClassName = _a.inputClassName;
    var logger = useLogger().logger;
    var onNameUpdated = function (name) {
        var newFilter = __assign(__assign({}, filter), { name: name });
        logger.debug("Filter editor - Notify filter update following name update: ", newFilter, " old: ", filter);
        notifyFilterUpdate && notifyFilterUpdate(newFilter);
        console.log("name updated");
    };
    var onFilterUpdated = function (updatedFilter) {
        var newFilter = __assign(__assign({}, filter), { filters: copy(updatedFilter) });
        logger.debug("Filter editor - Notify filter update following filter update: ", newFilter, " old: ", filter);
        notifyFilterUpdate && notifyFilterUpdate(newFilter);
    };
    return (_jsxs("div", __assign({ className: "h-60 overflow-x-auto overflow-y-auto pr-5" }, { children: [_jsx(Input, { name: "filterName", value: filter.name, placeholder: "Filter name", className: "p-2 ".concat(inputClassName), size: "sm", onChange: function (event) {
                    onNameUpdated(event.target.value);
                } }), _jsx("div", __assign({ className: "py-2" }, { children: _jsx("span", __assign({ className: "text-md" }, { children: filter.module })) })), _jsx(GroupEditor, { filter: filter.filters, onFilterUpdated: function (updatedFilter) {
                    logger.debug("Filter editor - Filter updated: ", filter.filters, " to ", updatedFilter);
                    onFilterUpdated(updatedFilter);
                }, module: module })] })));
}
